import "./Modal.css";
import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faShare } from "@fortawesome/free-solid-svg-icons";
import { toBlob } from "html-to-image";

function Modal({ message, handleModal }) {
  const ref = useRef(null);
  async function takeScreenshot() {
    let files = [];
    await toBlob(ref.current, {
      style: { borderRadius: 0 },
      skipAutoScale: true,
    }).then((dataUrl) => {
      const file = new File([dataUrl], "tes.jpg", {
        type: "image/jpeg",
      });
      files = [file];
    });
    await navigator.share({ files });
  }
  return (
    <div className="modal-background">
      <div ref={ref} className="screenshot-component">
        <div className="modal-container">
          <div className="modal-head">
            From {message.sender}
            <div>
              <button onClick={() => takeScreenshot(false)}>
                <FontAwesomeIcon icon={faShare} style={{fontSize:20}}/>
              </button>
              <button onClick={() => handleModal(false)}>
                <FontAwesomeIcon icon={faX} style={{fontSize:20}}/>
              </button>
            </div>
          </div>

          <div style={{width:300,height:200,maxHeight:700}} className="container-message">
            <div className="container-head">
              From {message.sender}
            </div>
            <textarea readonly="readonly" unselectable="on" style={{backgroundColor:"rgba(0,0,0,0)",width:"90%",height:"65%"}} className="modal-content" defaultValue={message.message} disabled></textarea>
          </div>

        <footer></footer>
        </div>
      </div>
    </div>
  );
}

export default Modal;
